import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { DeudaComponent } from '../../deuda/deuda/deuda.component';
import { Overlay } from '@angular/cdk/overlay';
import { InicioService } from 'src/app/inicio/inicio/inicio.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-impuestos',
  templateUrl: './impuestos.component.html',
  styleUrls: ['./impuestos.component.scss']
})
export class ImpuestosComponent implements OnInit {
 
  persona;
  ocultarAuto = false; //variable para ocultar los componentes
  ocultarInmueble = true; //
  ocultarBien = false ;//ocultar variable
  ocultarTasas = true;//ocultar tasas generales
  ocultarPlanPagos = false;//ocultar plan de pago
  ocultarObraPavimiento = false //ocultar Pavimiento
  tributo = "";
  status: boolean = false;
  nro_Jurisdiccion;
  constructor(public dialog: MatDialog,private overlay: Overlay,private service: InicioService,) { }

  ngOnInit() {

   

    this.nro_Jurisdiccion = environment.codigoJur;  
//     this.service.getTributoUsuario('035V7','20309765134').subscribe((response) => {
//       this.persona = response;
   
// //continuar
     
//       for(let i = 0;i < this.persona.length; i++){
//         this.tributo = this.persona[i].concepto;
//         if(this.tributo == "Tasa por Servicio a la Propiedad"){
//           this.ocultarInmueble = true;
//         }
//         if(this.tributo == "Tasas Generales"){
//           this.ocultarTasas = true;
//         }
//         if(this.tributo == "Plan de Pago"){
//           this.ocultarPlanPagos = true;
//         }
//         if(this.tributo == "Obra de Pavimento"){
//             this.ocultarObraPavimiento = true;
//         }
//       }
//      debugger;
    
//      // this.isVisible = false;
//     });

  }

  verdeuda(codigo : string , descripcion : string): void {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();
    const dialogRef = this.dialog.open(DeudaComponent, {
      panelClass: "new-customer-modal-dialog",
      width: '2000px',
      height: '89%',
      direction: 'ltr',
      data : {codigo : codigo, descripcion: descripcion, nrocta: null, cantdias : null, vienedeinicio: 'N'},
      scrollStrategy
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  clickEvent(){
    this.status = !this.status;       
}
cerrarSesion(): void {
  sessionStorage.clear();
}

sigimyt(){
  window.open(`${environment.urlportal}`, "_self");
}

}
